import OwnerController from "../owner_controller";
import { OWNER_REPORT_SOLD_OUT, GROUP_REPORT_SOLD_OUT } from '../../routes';
export default class extends OwnerController {
  static targets = ['nextLink', 'prevLink'];

  async connect() {
    await this.fetch();
  }

  async fetch() {
    const { restaurantId } = this.filter;
    if(restaurantId == 'all' || restaurantId == null) return this.showMessageBranch();

    this.setEmpty(this);
    this.setLoading(this);
    const { data } = await this.axios.get(this.soldOutUrl);
    this.processPartial(data);
  }

  showMessageBranch() {
    this.setEmpty(this);
    this.element.innerHTML = `<h5>
        Please select
        <span class="dark-red">Branch</span> to show report sold
      </h5>`;
  }

  async fetchNextMonth(e) {
    e.preventDefault();
    const { data } = await this.axios.get(this.soldOutUrl, {
      params: { selected_date: this.nextLinkTarget.getAttribute('data-selected-date') }
    });
    this.processPartial(data);
  }

  async fetchPrevMonth(e) {
    e.preventDefault();

    const { data } = await this.axios.get(this.soldOutUrl, {
      params: { selected_date: this.prevLinkTarget.getAttribute('data-selected-date') }
    });
    this.processPartial(data);
  }

  get soldOutUrl() {
    if(this.filter.restaurantGroupId == null)
      return OWNER_REPORT_SOLD_OUT;
    return GROUP_REPORT_SOLD_OUT;
  }
}
